module.exports = __webpack_public_path__ + "img/Flaw-remediation.c46503be.png";